import GenericReportMobile from '../_partials/GenericReportMobile';
import { useTranslation } from 'react-i18next';
import SoldExclusivesTableRowHeadingMobile from './SoldExclusivesTableRowHeadingMobile/SoldExclusivesTableRowHeadingMobile';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';

import s from './SoldExclusivesMobile.scss';

export default function SoldExclusivesMobile() {
  const { t } = useTranslation();

  const columns = [
    {
      key: 'totalSales',
      label: t(
        'studio.reports.section.soldExclusives.table.header.transactions'
      ),
      className: s['transactions'],
    },
    {
      key: 'uniqueCustomers',
      label: t(
        'studio.reports.section.soldExclusives.table.header.uniqueOwners'
      ),
    },
    {
      key: 'salesVolume',
      label: t('studio.reports.section.soldExclusives.table.header.sales'),
      format: formatDollars,
    },
  ];

  return (
    <GenericReportMobile
      reportType="soldExclusives"
      headingKey="studio.reports.section.soldExclusives.title"
      descriptionKey="studio.reports.section.soldExclusives.description"
      descriptionTranslationOptions={{
        postProcess: ['reactPostprocessor'],
        learnMoreLink: (
          <a
            className="text-link-level-2-tertiary"
            href={t(
              'studio.reports.section.soldExclusives.description.learnMoreLink.url'
            )}
          >
            {t(
              'studio.reports.section.soldExclusives.description.learnMoreLink.text'
            )}
          </a>
        ),
      }}
      columns={columns}
      RowHeading={SoldExclusivesTableRowHeadingMobile}
      showTotal
    />
  );
}
